import demographics from './widgets/Demographics';
import outcomes from './widgets/Outcomes';
import riskFactors from './widgets/RiskFactors';
import protectiveFactors from './widgets/ProtectiveFactors';
import positiveOutcomes from './widgets/PositiveOutcomes';
export default [demographics, outcomes, riskFactors, protectiveFactors, positiveOutcomes];
